export class DockingStationsMapManager {
    constructor(parent) {
        this.parent = parent;
    }
    hasCustomSelectionFilters() {
        return true;
    }
    setCustomSelectionFilters(locations) {
        if (typeof locations === "undefined" || locations.length == 0) {
            this.parent.map.setFilter(this.parent.locationLayerId, ["all", ["has", "_location_id"], ["has", "_score:bicycle.commute:safety"]]);
            this.parent.map.setFilter(this.parent.locationLayerId + "-back", ["all", ["has", "_location_id"], ["has", "_score:bicycle.commute:safety"]]);
            this.parent.map.setFilter(this.parent.locationLabelsLayerId, ["all", ["has", "_location_id"], ["has", "_score:bicycle.commute:safety"]]);
        }
        else {
            const filter = ["any"];
            locations.forEach(l => {
                filter.push(["==", "_location_id", l]);
            });
            this.parent.map.setFilter(this.parent.locationLayerId, filter);
            this.parent.map.setFilter(this.parent.locationLayerId + "-back", filter);
            this.parent.map.setFilter(this.parent.locationLabelsLayerId, filter);
        }
    }
    getVehicleTypeSettings() {
        return [
            {
                vehicleType: 2,
                color: "#0000FF",
                maxTripCount: 500
            }
        ];
    }
    setLocationLayerVehicleTypeLayerFilters(showScore, showRelevantLocations) {
        if (!showRelevantLocations) {
            this.parent.map.setLayoutProperty(this.parent.locationLayerId, "visibility", "none");
            this.parent.map.setLayoutProperty(this.parent.locationLayerId + "-back", "visibility", "none");
            this.parent.map.setLayoutProperty(this.parent.locationLabelsLayerId, "visibility", "none");
            return;
        }
        this.parent.map.setLayoutProperty(this.parent.locationLayerId, "visibility", "visible");
        this.parent.map.setLayoutProperty(this.parent.locationLayerId + "-back", "visibility", "visible");
        this.parent.map.setLayoutProperty(this.parent.locationLabelsLayerId, "visibility", "visible");
        if (showScore) {
            const scoreAtLocation = ["case", ["has", "_score:bicycle.commute:safety"],
                ["get", "_score:bicycle.commute:safety"], ["literal", 0]];
            const colorExpressionAtLocation = [
                "interpolate",
                ["linear"],
                ["to-number", scoreAtLocation, 0],
                0,
                "#000000",
                0.6,
                "#000000",
                0.601,
                "#ff0000",
                0.77,
                "#ff0000",
                0.771,
                "#cccccc",
                1,
                "#cccccc",
                1.01,
                "#ffff00",
                1.5,
                "#ffff00"
            ];
            this.parent.map.setPaintProperty(this.parent.locationLayerId, "circle-color", colorExpressionAtLocation);
            this.parent.map.setFilter(this.parent.locationLayerId, ["all", ["has", "_location_id"], ["has", "_score:bicycle.commute:safety"]]);
            this.parent.map.setFilter(this.parent.locationLayerId + "-back", ["all", ["has", "_location_id"], ["has", "_score:bicycle.commute:safety"]]);
            this.parent.map.setFilter(this.parent.locationLabelsLayerId, ["all", ["has", "_location_id"], ["has", "_score:bicycle.commute:safety"]]);
        }
        else {
            this.parent.map.setPaintProperty(this.parent.locationLayerId, "circle-color", "#FFF");
            this.parent.map.setFilter(this.parent.locationLayerId, ["all", ["has", "_location_id"], ["has", "_score:bicycle.commute:safety"]]);
            this.parent.map.setFilter(this.parent.locationLayerId + "-back", ["all", ["has", "_location_id"], ["has", "_score:bicycle.commute:safety"]]);
            this.parent.map.setFilter(this.parent.locationLabelsLayerId, ["all", ["has", "_location_id"], ["has", "_score:bicycle.commute:safety"]]);
        }
    }
    hasLocationLayer() {
        return true;
    }
}
